import { render, staticRenderFns } from "./BetgameTippen.vue?vue&type=template&id=084f3778&scoped=true"
import script from "./BetgameTippen.vue?vue&type=script&lang=js"
export * from "./BetgameTippen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084f3778",
  null
  
)

export default component.exports